import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IRecordsOf } from 'src/app/common/models/IRecordsOf';
import { ClearRecordsOf, SetRecordsOfData } from './records-of.actions';


export class RecordsOfStateModel {
  data: IRecordsOf;
}

@State<RecordsOfStateModel>({
    name: 'recordsOf',
    defaults: {
      data: null
    }
})

@Injectable()
export class RecordsOfState {

    @Selector()
    static getRecordsOfState(state: RecordsOfStateModel) {
        return state;
    }

    @Selector()
    static getRecordsOfStateData(state: RecordsOfStateModel) {
        return JSON.parse(state?.data?.rowData);
    }


    @Action(SetRecordsOfData)
    public setRecordsOf({ getState, setState }: StateContext<RecordsOfStateModel>,
       { data }: SetRecordsOfData) {
        const state = getState();
        setState({ ...state, data });
    }

    @Action(ClearRecordsOf)
    public clearRecordsOf({ getState, setState }: StateContext<RecordsOfStateModel>) {
        const state = getState();
        setState({ ...state, data: null });
    }
}
